import { ContentCopy, Delete, DynamicFeed } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const accent = "#14b8c6";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const options = Array.isArray(data.arrayOption) ? data.arrayOption : [];

  return (
    <div
      style={{
        width: 220,
        backgroundColor: "#ffffff",
        borderRadius: 8,
        border: "1px solid #e5e7eb",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.10)",
        overflow: "hidden"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: accent,
          width: 8,
          height: 8,
          left: -4,
          top: "50%"
        }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          height: 34,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 10px 0 12px",
          background: "linear-gradient(180deg, rgba(20,184,198,0.10), rgba(20,184,198,0.02))",
          borderBottom: "1px solid rgba(20, 184, 198, 0.10)"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            style={{
              width: 21,
              height: 21,
              borderRadius: 5,
              background: "rgba(20, 184, 198, 0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <DynamicFeed sx={{ width: 15, height: 15, color: accent }} />
          </span>
          <strong style={{ color: accent, fontSize: 13, fontWeight: 600 }}>Menu</strong>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ContentCopy
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
            sx={{ width: 15, height: 15, color: "#6b7280", cursor: "pointer" }}
          />
          <Delete
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            sx={{ width: 15, height: 15, color: "#6b7280", cursor: "pointer" }}
          />
        </div>
      </div>

      <div style={{ padding: "12px 14px 8px" }}>
        <div
          style={{
            color: "#374151",
            fontSize: 12,
            lineHeight: 1.45,
            marginBottom: options.length ? 10 : 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          }}
        >
          {data.message || "Escolha uma opção:"}
        </div>

        {options.map((option, index) => (
          <div
            key={`${option.number}-${index}`}
            style={{
              color: "#4b5563",
              fontSize: 11,
              lineHeight: 1.6,
              position: "relative",
              paddingRight: 12
            }}
          >
            {`${option.number}. ${option.value}`}
            <Handle
              type="source"
              position="right"
              id={`a${option.number}`}
              style={{
                top: 74 + 20 * index,
                background: accent,
                width: 8,
                height: 8,
                right: -18
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
      </div>
    </div>
  );
});
